module.exports = __webpack_public_path__ + "img/img45.b6b5da0a.svg";